import 'angular:locale/data:zh-Hant';
import 'angular:locale/data:en';
import 'angular:locale/data:ja';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
